import "./Clarification.module.css";
import Header from "@/reusable_sections/Header";
import LatestProgramUpdates from "./sections/LatestProgramUpdates";
import KlarifikasiHero from "./sections/KlarifikasiHero";
import Clarification from "./sections/Clarification";
import InformasiKontak from "@/reusable_sections/Footer";
import Ketentuanklarifikasi from "./sections/Ketentuanklarifikasi";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
export default function ClarificationPage() {
  return <div className="relative min-h-screen">
      <Header />
      <KlarifikasiHero />
      <Clarification />
      <LatestProgramUpdates />
      <Ketentuanklarifikasi />
      <GlossyBottomNavigation />
      <InformasiKontak />
    </div>;
}